import React from "react";
import styled from "styled-components";
import { FaFacebook, FaTwitter, FaInstagram, FaTiktok } from "react-icons/fa";

const ClientsContainer = styled.div`
  width: 100%;
  padding: 100px 0;
  background: url("/img/bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
  background-attachment: fixed;

  @media (max-width: 768px) {
    padding: 50px 0;
  }
`;

const ClientWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    margin: 10px;
  }
`;

const ClientTitle = styled.h1`
  font-size: 20px;
  color: black;
  margin-top: 10px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const IconLink = styled.a`
  color: blue;
  text-decoration: none;

  &:hover {
    opacity: 0.7;
    transition: opacity 0.3s ease;
  }
`;

const Icon = styled.div`
  font-size: 2.5rem;

  &:hover {
    transform: scale(1.1);
    transition: transform 0.3s ease;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Row = styled.div`
  display: flex;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const Clients = () => {
  return (
    <ClientsContainer>
      <div className="container">
        <Row>
          <ClientWrapper>
            <IconLink href="https://web.facebook.com/wheny.snoopy">
              <Icon>
                <FaFacebook />
              </Icon>
            </IconLink>
            <ClientTitle>Follow and get Promo</ClientTitle>
          </ClientWrapper>
          <ClientWrapper>
            <IconLink href="https://www.tiktok.com/@priskawheny">
              <Icon>
                <FaTiktok />
              </Icon>
            </IconLink>
            <ClientTitle>Info Update Promo</ClientTitle>
          </ClientWrapper>
          <ClientWrapper>
            <IconLink href="https://www.instagram.com/priska_w.k/">
              <Icon>
                <FaInstagram />
              </Icon>
            </IconLink>
            <ClientTitle>Follow and get Free</ClientTitle>
          </ClientWrapper>
        </Row>
      </div>
    </ClientsContainer>
  );
};

export default Clients;
